import React from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationAlert } from "../../../../cargotic-webapp-component";

const BankAccountDeleteConfirmationAlert = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationAlert
      title={t("webapp:settings.title.deleteBankAccount")}
      content={t("webapp:settings.prompt.delete-bank-account")}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default BankAccountDeleteConfirmationAlert;
